<div class="po-row cp-div-external cp-widget" >
  <div class="po-row">
    <div class="po-xl-9 po-lg-9 po-md-9 po-sm-9"></div>
    <div class="po-xl-3 po-lg-3 po-md-3 po-sm-3" [hidden]="!this.isInfo">
        <span class="po-icon po-icon-info cp-widget-icon" p-tooltip-position="top" [p-tooltip]="tooltipMessage">
        </span>
    </div>
  </div>
  <div class="po-row" [style.opacity]="graphicOpacity" >
    <ng-content ></ng-content>
  </div>
  <po-loading-overlay [hidden]="isHideLoading" p-size="sm">
  </po-loading-overlay>
</div>
